var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "forbidTheSale" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.from },
        on: { Refresh: _vm.onHandleRefresh, search: _vm.onSearch },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.additem } },
                  [_vm._v("新增")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex tablewearo" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "100px",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "供货商名称", align: "center", prop: "title" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "集配中心",
                  align: "center",
                  prop: "logisticBusinessName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "对接业务类型",
                  align: "center",
                  prop: "buyerCreatorTypeName",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "联系人", align: "center", prop: "fullname" },
              }),
              _c("el-table-column", {
                attrs: { label: "联系电话", align: "center", prop: "mobile" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "对接业务",
                  align: "center",
                  prop: "buyerName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "禁售品类",
                  align: "center",
                  width: "300",
                  prop: "forbidTheSaleCategoryName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.forbidTheSaleCategoryName.length <= 10
                          ? _c("div", [
                              _vm._v(
                                _vm._s(scope.row.forbidTheSaleCategoryName)
                              ),
                            ])
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cofirmclcik(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.forbidTheSaleCategoryName.substring(
                                      0,
                                      11
                                    )
                                  ) + "..."
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandleProhibited(scope.row)
                              },
                            },
                          },
                          [_vm._v("禁售品类")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.remove(scope.row)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.from.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("addforbidTheSale", {
        ref: "addforbidTheSaleref",
        on: { onchange: _vm.onHandleRefresh },
      }),
      _c("ProhibitedCategories", {
        ref: "ProhibitedCategoriesref",
        on: { "on-refresh-list": _vm.hqlist },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }